<template>
  <div class="contentPage">
    <div class="potential">
      <div class="potential_title">
        <span>Clients list</span>
        <div class="blockRight">
          <button @click="onRefresh" class="mainBtn mainBtn-text">
            <span class="btnIco">
              <svg-sprite width="20" height="20" icon-id="refresh"></svg-sprite>
            </span>
            <span class="btnText">refresh</span>
          </button>
          <button @click="onAddClient" class="mainBtn">
            <span class="btnText">Create client</span>
          </button>
        </div>
      </div>
      <field
          margin="0 0 10px 0"
          height="initial"
          width="300px"
          placeholder="Enter search"
          :setInputValue="search"
          @updateInputWithEnter="onSearch"
          is-enter
          is-phone
      ></field>
      <div class="potential_body">
        <tab-block
          :tab="tab"
          :tab-list="tabList"
          custom-class="clientTabs"
          @updateTab="onTab($event)"
        >
          <v-tab-item :key="flag" v-for="({flag}) in tabList">
            <main-table
                padding="0 0 10px"
                :flag="flag"
                default-sort-by="id"
                :default-sort-desc="true"
                :headers="headers"
                :filters-list="clientsFilter"
                :list-items="clientsList"
                :is-hide-header="false"
                :items-per-page-amount="10"
                :pages="[10, 20, 50, 100, 200, 500, 'All']"
                :uniqId="isRefreshFilters"
                @updateClickButton="onClickButton"
                @updateEdit="onEdit"
                @updateChangeSort="onFilter"
                @updateRefreshFilters="onRefreshFilters"
            ></main-table>
          </v-tab-item>
        </tab-block>
      </div>
    </div>
    <add-clients
      v-if="isClients"
      :currentId="currentId"
      :typeDefault="type"
      :permissions="permissions"
      @updateClose="onAddClients(false)"
      @updateFilterList="onFilterList"
    ></add-clients>
    <remove-block
      v-if="isRemove"
      @updateRemoveItem="onRemoveItem"
      @updateRemoveClose="onRemoveClose"
    ></remove-block>
    <table-settings
        v-if="isTableSettingsDrawer"
        @updateSettingsSave="onSettingsSave('clients')"
        @updateSettingsCancel="onSettingsCancel"
        @updateSettingsClose="onSettingsClose"
        @updateSettingsAll="onSettingsAll"
        :settings="getSettings"
    ></table-settings>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// async components
const AddClients = () => import("@/components/Maintenance/Clients/AddClients/AddClients");
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");
// shared
import TabBlock from "@/shared/TabBlock/TabBlock";
// helper
import getClonedObject from "@/helper/getClonedObject";
import getUniqId from "@/helper/getUniqId";
import debounce from "lodash.debounce";
// constants
import { PERMISSIONS } from "@/constants/constants";
import clientsTabs from "@/pages/Maintenance/Clients/clientsTabs";
// mixins
import settingsMixins from "@/mixins/settingsMixins";

export default {
	name: "Client",
	mixins: [ settingsMixins ],
	components: {
		TabBlock,
		AddClients,
		RemoveBlock,
	},
	computed: mapGetters([ "clientsFilter", "clientsList", "permissions" ]),
	data: () => ({
		tabList: [],
		tab: 0,
		type: 1,
		isRefresh: null,
		isFilterList: null,
		isClients: false,
		currentId: null,
		isRemove: false,
		removeId: null,
		isCommentsPopup: false,
		isUploadComponent: false,
		uniqId: null,
		isRefreshFilters: null,
		search: '',
	}),
	methods: {
		...mapActions([
			"onClients",
			"onRemoveClients",
			"onClearClientsFilter",
			"onClientsFilter",
			"onClientsCreate",
			"setAlert",
		]),
		async onSearch({ value }) {
			this.search = value;
			if (value) {
				const { tabsActive, list } = await this.onClientsFilter({ search: value, isSearch: true });
				if (tabsActive.length) {
					this.tabList = this.tabList.map(item => {
						item.active = tabsActive.some(body => body === item.type);
						return item;
					});
     
					const indexItem = this.tabList.findIndex(item => item.type === tabsActive[0]);
     
					const phone = list[0].phone;
					await this.onTab(indexItem, { filter_phone: [ phone ] });
				} else {
					this.setAlert({ type: "error", message: "No result" });
				}
			} else {
				this.onRefresh();
			}
		},
		onAddClient() {
			this.isClients = true;
		},
		async onTab(value, filter = {}) {
			const { type } = this.tabList[value];
			await this.onClientsFilter({ type, ...filter });
			this.tab = value;
			this.type = type;
		},
		onEvent({ flag }) {
			if (flag === "upload") this.isUploadComponent = true;
		},
		onRefresh() {
			this.isRefreshFilters = getUniqId();
			this.search = '';
			this.tabList = getClonedObject(clientsTabs);
		},
		onRefreshFilters: debounce(async function() {
			await this.onClientsFilter({ type: this.type });
		}, 300),
		async onFilter(info) {
			this.filterModList = info.filterModList;
			await this.onClientsFilter({
				type: this.type,
				...info.filterModList,
			});
		},
		onClickButton({ key, item }) {
			if (key === "delete") {
				this.getRemoveItem(item.id);
			}

			if (key === "edit") {
				this.currentId = item.id;
				this.isClients = true;
			}
		},
		async onCreate() {
			this.currentId = null;
			this.isClients = true;
		},
		onEditMain({ line }) {
			if (
				this.permissions[PERMISSIONS.EDIT] ||
        this.permissions[PERMISSIONS.VIEW]
			) {
				this.currentId = line.id;
				this.isClients = true;
			}
		},
		refreshFilters() {
			this.isRefresh = getUniqId();
		},
		onFilterList() {
			this.isFilterList = getUniqId();
		},
		onRemoveClose() {
			this.isRemove = false;
		},
		onAddClients(value) {
			this.currentId = null;
			this.isClients = value;
		},
		onEdit({ line }) {
			this.currentId = line.id;
			this.isClients = true;
		},
		getRemoveItem(id) {
			this.removeItem = id;
			this.isRemove = true;
		},
		async onRemoveItem() {
			await this.onRemoveClients(this.removeItem);
			this.isRemove = false;
		},
	},
	created() {
		this.tabList = getClonedObject(clientsTabs);
	},
	async mounted() {
		await this.onClientsFilter({ type: this.type });
	}
};
</script>

<style scoped lang="scss">
@import "clients";
</style>
